export function NullString (value: String) {
    if (value instanceof String) {
        throw Error('NullString получил на вход не строку');
    }
    return value ? value : '';
}
